import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'


import NavBar from './components/navbar/NavBar';
import HomePage from './pages/HomePage';

import Footer from './components/footer/Footer';
import BackToTopButton from './components/backToTop/BackToTopButton';

import ProductDetails from './components/productDetails/ProductDetails';
import SiteLoading from './components/siteloading/SiteLoading';
import ShoppingCart from './components/shoppingcart/ShoppingCart';
import ContactUs from './components/contactUs/ContactUs';
import FilterableProductPage from './components/filterableProducts/FilterableProductPage';
import NotFound from './pages/NotFound';
import AdminPanel from './pages/AdminPanel';


class App extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }
    }

    componentDidMount() {
        // AOS.init();

        setInterval(() => {
            this.setLoading(false);
        }, 2500);
    }

    setLoading = (pr) => {
        this.setState({
            loading: pr
        })
    }

    render() {

        // if (this.state.loading) {
        //     return <SiteLoading />
        // }
        return (
            <div className="App" >
                <BackToTopButton />
                <NavBar />
                <br /><br /><br />   <br />
                <BrowserRouter>
                    <Switch>
                        <Route path="/" component={HomePage} exact />
                        <Route path="/product" component={ProductDetails} exact />
                        <Route path="/cart" component={ShoppingCart} exact />
                        <Route path="/contact" component={ContactUs} exact />
                        <Route path="/prod" component={FilterableProductPage} exact />
                        <Route path="/404" component={NotFound} exact />
                        <Route path="/adminPanel" component={AdminPanel} exact />
                        <Redirect to="/404" />
                    </Switch>
                </BrowserRouter>
                <br /><br /><br />
                <Footer />
                {/* <MessengerCustomerChat
                    pageId="1895382890692545"
                    appId="215971755540323"
                /> */}
            </div>
        );
    }
}

export default App;